"use client"

import SelectPlacementSkeleton from "./SelectPlacement/index.skeleton"
import { FC } from "react"

type SelectDestinationSkeletonProps = {
  size?: 'small' | 'default'
}

const SelectDestinationSkeleton: FC<SelectDestinationSkeletonProps> = ({ size = 'default' }) => {

  return (
    <SelectPlacementSkeleton
      size={size}
    />
  )
}

SelectDestinationSkeleton.displayName = 'SelectDestinationSkeleton'

export default SelectDestinationSkeleton